import { startWith } from 'rxjs/operators';
import { ActivityStatus } from './../../../models/activities/activity';
import { ToastrService } from 'ngx-toastr';
import {
  Component,
  OnInit,
  Input,
  Inject,
  forwardRef,
  ViewChild,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  TemplateRef
} from '@angular/core';
import {
  ActivityModel,
  Activity,
  FormActivity
} from '../../../models/activities';
import { UntypedFormGroup } from '@angular/forms';
import { WorkflowApplication, Document, Actions, ApplicationStatus } from 'src/app/models';
import {
  DocumentService,
  WorkflowService,
  SecurityService,
  ValidationService,
  DataEntityFactory,
  ActivityFactory,
  ActivityUtilities,
  WorkflowContextService
} from 'src/app/services';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { WorkflowApplicationActivityDataAudit } from 'src/app/models/workflow-application-activity-data-audit';
import { WorkflowApplicationActivityAuditDetails } from 'src/app/models/workflow-application-activity-audit-details';
import { DataEntity } from 'src/app/models/data-entities';
import { ActivityViewComponent } from 'src/app/components/workflow/activities/activity-editor/activity-view/activity-view.component';
import { LayoutService } from 'src/app/services/layout.service';
import { svgs } from 'src/assets/export.assets';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { WorkflowApplicationsJanusService } from '../../admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';

@Component({
  selector: 'wm-application-readonly',
  templateUrl: './application-readonly.component.html',
  styleUrls: ['./application-readonly.component.css'],
  standalone: false
})
export class ApplicationReadonlyComponent implements OnInit {
  editIcon = svgs.editIcon.name
  @Input({ required: false }) appStatusCode: ApplicationStatus
  @Input() applicationId: string;
  @Input() application: WorkflowApplication;
  @Input() activities: Activity<ActivityModel>[];
  @Input({ required: false }) editApplicationJanusView: boolean = false;
  form: UntypedFormGroup;
  @Input() isTestApplication: boolean;
  
  editingJanusActivityId: string | null = null;
  private editingJanusActivityDataId:string | null = null
  editingJanusActivityIsInProgress: boolean = false;
  canEditNotes: boolean;
  canEditActivity: boolean;
  @ViewChild('EditCompletedActivity', { static: true })
  private editCompletedActivity: ModalConfirmComponent;
  @ViewChild('ActivityHistory', { static: true })
  private activityHistory: ModalConfirmComponent;
  ActivityStatus = ActivityStatus;
  @ViewChild('editActivityInput', { static: false })
  private editActivityInput: ActivityViewComponent;
  @ViewChildren('activityViewItem')
  private activityViewItems: QueryList<ActivityViewComponent>;
  @ViewChild('tabs', { static: false })
  showRemove = false;
  internalDocuments: Document[];
  externalDocuments: Document[];
  activityForm: UntypedFormGroup;
  editingActivity: Activity<ActivityModel>;
  activityHistoryItems: WorkflowApplicationActivityDataAudit[] = null;
  historyLoading = false;
  auditLoading: { [key: string]: boolean } = {};
  auditData: { [key: string]: WorkflowApplicationActivityAuditDetails } = {};
  activeTabId: string;
  templateForPermitForm = false;
  isEditedActivitySaving: boolean = false

  janusExternalNotesList: any[] = [];
  hasNewExternalNotes = false;
  isLoadingJanusNotes = false;

  auditEntities: {
    [key: string]: {
      [key: string]: {
        oldEntity: DataEntity;
        newEntity: DataEntity;
        templateCode: string;
      };
    };
  } = {};

  constructor(
    public layoutService: LayoutService,
    private _workflowSvc: WorkflowService,
    private _securitySvc: SecurityService,
    private _toastrSvc: ToastrService,
    private ref: ChangeDetectorRef,
    public context: WorkflowContextService,
    private workflowApplicationsJanusSvc : WorkflowApplicationsJanusService
  ) {
    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
  }

  activityIdx: { [key: string]: Activity<ActivityModel> } = {};

  ngOnInit() {
    this.form = new UntypedFormGroup({});
    if (this.application) {
      this._securitySvc
        .isLoginEntitled(Actions.WORKFLOW_APPLICATIONS_EDIT)
        .subscribe(result => {
          this.canEditNotes = result;
        });
      this._securitySvc
        .isLoginEntitled(Actions.EDIT_COMPLETED_APPLICATIONS)
        .subscribe(result => {
          this.canEditActivity = result;
        });
        
      if (this.isJanusView && this.applicationId) {
         this.isLoadingJanusNotes = true;
         this._workflowSvc.getExternalWorkflowApplicationNotes(this.applicationId).subscribe((res: any) => {
             this.janusExternalNotesList = this.extractNotes(res);
             this.hasNewExternalNotes = this.janusExternalNotesList.length > 0;
             this.isLoadingJanusNotes = false;
             this.ref.detectChanges();
         }, () => {
             this.isLoadingJanusNotes = false;
             this.ref.detectChanges();
         });
      }
    }

    if (this.activities) {
      this.activities.forEach(a => {
        this.activityIdx[a.activityDataId] = a;
      });
    }
  }

  private extractNotes(res: any): any[] {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.$values)) return res.$values;
    const candidates = [res.data, res.result, res.results, res.items, res.rows, res.notes, res.noteHistory];
    for (const c of candidates) {
        if (Array.isArray(c)) return c;
        if (c && Array.isArray(c.$values)) return c.$values;
    }
    return [];
  }
  
  get isCategoryDefinedLayout(): boolean {
    const result = !!(
      this.context.useNewLayout === true &&
      this.context.janusLayout === 'staff' &&
      this.workflowApplicationsJanusSvc.getData()
        .inlineApplicationSummaryDetails?.categoriesDefined === true
    );
      return result;
  }

  get isJanusView(): boolean {
    return this.templateForPermitForm || this.editApplicationJanusView;
  }

  get showJanusNotesCard(): boolean {
    return !!this.isJanusView && (this.hasExternalNotes || this.hasNewExternalNotes || this.isLoadingJanusNotes);
  }

  get hasExternalNotes(): boolean {
    return this.hasNoteContent(this.application?.externalNotes);
  }

  private hasNoteContent(value?: string): boolean {
    if (!value) {
      return false;
    }
    const text = value
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim();
    return text.length > 0;
  }

  saveNotes() {
    const internalNotes: string = this.application.internalNotes;
    const externalNotes: string = this.application.externalNotes;

    this._workflowSvc
      .saveWorkflowApplicationNotes(
        this.applicationId,
        internalNotes,
        externalNotes
      )
      .subscribe(() => {
        this._toastrSvc.success('Application Notes Saved');
      });
  }



  onEditIconClick = (template: TemplateRef<any>, activityDataId: string, activityIsInProgress: boolean = false) => {
    return {
      text: template,
      onClick: () => {
         this.editingJanusActivityDataId = null;
         this.editingJanusActivityIsInProgress = false;

        if (this.appStatusCode === 1) {
          this.underProgressWarningModalData = {
            ...this.underProgressWarningModalData,
            open: true
          }

          this.editingJanusActivityDataId = activityDataId;
          this.editingJanusActivityIsInProgress = activityIsInProgress;

        } else {
          this.editActivity(activityDataId)
        }

      }
    }
  }

  viewActivity(activityDataId: string) {
    this.activeTabId = activityDataId;
    if (this.activityIdx[activityDataId] && !this.activityIdx[activityDataId].preparedForScreen) {
      this._workflowSvc.getCompletedApplicationActivityForViewing(this.applicationId, activityDataId).subscribe(activity => {
        this.activityIdx[activityDataId] = activity;
        const idx = this.activities.findIndex(a => a.activityDataId == activityDataId);
        if (idx > -1) {
          this.activities[idx] = activity;
        }
      });
    }
  }
  get allActivitiesPrepared(): boolean {
    return this.activities?.every(a => a.preparedForScreen);
  }

  editActivity(activityDataId: string) {
    const handleActivity = (activity: any) => {
      if (this.editActivityInput && this.editActivityInput.view) {
        this.editActivityInput.view.destroy();
      }

      // clone the activity so it doesn't get udpated by the input if canceled
      const clonedActivity: Activity<ActivityModel> = ActivityUtilities.convertActivitiesJsonToClasses(
        [ActivityFactory.createActivity(activity, activity)]
      )[0];

      this.activityForm = new UntypedFormGroup(
        ValidationService.createValidationGroup(clonedActivity)
      );

      this.editingActivity = clonedActivity;
      if (this.editApplicationJanusView) {
        this.editingJanusActivityId = activityDataId
      } else {
        this.editCompletedActivity.moduleId = this.editingActivity.id;
        this.editCompletedActivity.open();
      }

      this.ref.detectChanges();
    };

    if (this.editingJanusActivityIsInProgress) {
      this._workflowSvc.getInProgressApplicationActivityForEditing(this.applicationId, activityDataId).subscribe(handleActivity);
    } else {
      this._workflowSvc.getCompletedApplicationActivityForEditing(this.applicationId, activityDataId).subscribe(handleActivity);
    }
  }

  onCancelButtonClick = () => {
    return {
      text: 'CANCEL',
      onClick: () => {
        this.cancelInlineEdit()
      }
    }
  }

  onSaveButtonClick = (template: TemplateRef<any>) => {
    return {
      text: this.isEditedActivitySaving ? template : 'SAVE',
      onClick: () => {
        this.updateActivity()
      }
    }
  }
  cancelEdit() {
    if (this.editActivityInput && this.editActivityInput.view) {
      this.editActivityInput.view.destroy();
    }
    this.editingActivity = null;
    this.activityForm.reset();
  }
  cancelInlineEdit() {
    this.editingJanusActivityId = null;
    this.editingActivity = null;
    this.activityForm?.reset();
  }

  closeEdit() {
    this.editCompletedActivity.cancel();
  }

  goNext() {
    this.editCompletedActivity.accept();
  }

  public updateActivity(evt?: any) {
    const editAct = this.editingActivity;
    this.isEditedActivitySaving = true
    this.editActivityInput.persistChildComponent().then(value => {
      const handleNavigateResponse = (resp: any) => {
        const act = resp.activity;

        if (editAct && this.activities) {
          const listInActivity = this.activities
            .filter(a => a != null)
            .find(
              a => a.activityDataId == editAct.activityDataId
            );

          if (listInActivity) {
            const editIdx = this.activities.indexOf(listInActivity);

            if (editIdx > -1 && act) {
              this.activeTabId = act.activityDataId;
              this.activities[editIdx] = act;

              if (this.activityViewItems) {
                const viewComp = this.activityViewItems.find(
                  f =>
                    f.activity &&
                    f.activity.activityDataId ==
                    editAct.activityDataId
                );

                if (viewComp) {
                  viewComp.loadView(act);
                }
              }
            }
          }
        }
        if (this.editApplicationJanusView) {
          this.isEditedActivitySaving = false
          this._toastrSvc.success('Activity updated successfully')
          this.cancelInlineEdit()
        } else {
          this.closeEdit();
        }
      };

      if (this.editingJanusActivityIsInProgress) {
        this._workflowSvc
          .submitWorkflowActivity(this.applicationId, editAct, false)
          .subscribe(() => {
            this._workflowSvc
            .navigateToActivity(
              this.applicationId,
              editAct.activityDataId,
              true
            )
            .subscribe(handleNavigateResponse);
        });
      } else {
        this._workflowSvc
          .saveWorkflowActivity(this.applicationId, editAct, true)
          .subscribe(() => {
            this._workflowSvc
              .navigateToActivity(
                this.applicationId,
                editAct.activityDataId,
                true
              )
              .subscribe(handleNavigateResponse);
      });
      }
    });
  }

  viewActivityHistory(activity: Activity<ActivityModel>) {
    this.historyLoading = true;

    this.activityHistory.moduleId = activity.id;
    this.activityHistory.title = activity.model.screenName + ' History';
    this.activityHistory.open();

    this._workflowSvc
      .getActivityDataAudit(this.applicationId, activity.activityDataId)
      .subscribe(result => {
        this.historyLoading = false;
        this.activityHistoryItems = result;
      });
  }

  closeHistory() {
    this.activityHistoryItems = null;
  }

  historyExpand(e) {
    if (e.nextState == true) {
      this.expandAudit(e.panelId); // id of the panel is the audit id
    }
  }

  auditEntityKeys(auditId) {
    if (this.auditEntities && this.auditEntities[auditId]) {
      return Object.keys(this.auditEntities[auditId]);
    } else {
      return [];
    }
  }

  expandAudit(auditId: string) {
    this.auditLoading[auditId] = true;
    this.auditEntities[auditId] = null;

    // get full details for the audit record
    this._workflowSvc
      .getActivityDataAuditDetails(this.applicationId, auditId)
      .subscribe(details => {
        this.auditLoading[auditId] = false;
        this.auditData[auditId] = details;

        // display the view of the activity if there is a newValue for the activity
        if (details.activityInfo.newValue) {
        }

        if (details.entityDetails) {
          const entityDEs = {};
          details.entityDetails.forEach(ed => {
            entityDEs[ed.templateCode] = {
              oldEntity: ed.oldEntity,
              newEntity: ed.newEntity,
              templateCode: ed.templateCode
            };
          });

          this.auditEntities[auditId] = entityDEs;
        }
      });
  }

  underProgressWarningModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'This application is still in progress',
    modalSubDescp: 'Click “Yes” to go edit the activity ',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };

  handleUnderProgressWarningModalAccepted() {
    if(this.editingJanusActivityDataId){
      this.editActivity(this.editingJanusActivityDataId)
    }
  }

  handleUnderProgressWarningModalModalRejected() {}
}
